import React from 'react';

// Components

const ObjectTemplate = (props) => {
  const { properties, uiSchema } = props;
  const options = uiSchema["ui:options"];
  const title = options && options.title;

  let styles = {};
  
  if(options && options.styles) {
    styles = options.styles;
  }
  
  return (
    <div style={styles.objContainer}>
      <div style={styles && styles.objTitle}>{title}</div>
      <div style={styles && styles.objInnerContainer}>
        {properties.map((prop, i) => {
          const { uiSchema } = prop.content.props;
          const options = uiSchema["ui:options"];

          let styles = {};
          if(options && options.styles) {
            styles = options.styles;
          }
          return (
            <div 
              key={prop.name + "-" + "i"} 
              style={styles && styles.field}>
              {prop.content}
            </div>
            )
        })}
      </div>
    </div>
  );
};

export default ObjectTemplate;